export default function OutlineButton({ title, toggleModal }) {
  return (
    <button
      className="group relative xl:w-auto lg:w-auto sm:w-auto w-full flex h-[52px] py-3 px-10 items-center justify-center gap-2 overflow-hidden bg-transparent border border-solid border-[#7C46EF] rounded-[10px] text-[#7C46EF] lg:shadow-xl text-base font-medium uppercase transition-all duration-700 ease-out before:absolute before:h-0 before:w-0 before:rounded-[10px] before:bg-[linear-gradient(269.02deg,#FF37EB_10.44%,#7c46ef_60%)] before:duration-700 before:ease-out hover:shadow-[#7c46ef]/20 hover:before:h-56 hover:before:w-full lg:mb-0 mb-4"
      onClick={toggleModal}
    >
      <span className="relative z-10 group-hover:text-white">
        {title}
      </span>
      {/* <svg
        className="w-4 h-4 text-[#7C46EF] group-hover:text-white z-10"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M14 5l7 7m0 0l-7 7m7-7H3"
        />
      </svg> */}
    </button>
  );
}
